import React, { useEffect, useState, createElement } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { BookOpenIcon, HeadphonesIcon, UtensilsCrossedIcon, ZapIcon, HeartIcon, MoonIcon, LeafIcon, ClockIcon, CheckIcon, StarIcon, ShieldIcon, ArrowRightIcon, FlameIcon, BrainIcon, ActivityIcon, ChevronDownIcon, XIcon, PlusIcon, MinusIcon } from 'lucide-react';
// Shopify cart URLs based on order bump selections
const CART_URLS = {
  base: 'https://manosquegeneran.com/cart/48375336665315:1',
  bump1: 'https://manosquegeneran.com/cart/48477078094051:1',
  bump2: 'https://manosquegeneran.com/cart/48477071900899:1',
  both: 'https://manosquegeneran.com/cart/48477072654563:1' // Both bumps
};
function getPurchaseUrl(bump1: boolean, bump2: boolean): string {
  if (bump1 && bump2) return CART_URLS.both;
  if (bump1) return CART_URLS.bump1;
  if (bump2) return CART_URLS.bump2;
  return CART_URLS.base;
}
// ── Meta Pixel ──────────────────────────────────────────────────────
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}
function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return;
  const fbq: any = (...args: unknown[]) => {
    if ((fbq as any).callMethod) (fbq as any).callMethod(...args);else (fbq as any).queue.push(args);
  };
  window.fbq = fbq;
  window._fbq = fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', '1651839656232002');
}
// ───────────────────────────────────────────────────────────────────
export function SalesPage() {
  const [showStickyBar, setShowStickyBar] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const totalPrice = (14.27 + (bump1 ? 9 : 0) + (bump2 ? 9 : 0)).toFixed(2);
  const purchaseUrl = getPurchaseUrl(bump1, bump2);
  useEffect(() => {
    // Fire PageView on mount
    initMetaPixel();
    window.fbq('track', 'PageView');
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setShowStickyBar(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen w-full font-sans" style={{
    backgroundColor: '#F8F9FA',
    color: '#111827'
  }} data-id="element-3">
      {/* ━━━ ANNOUNCEMENT BAR ━━━ */}
      <div className="sticky top-0 z-50 w-full py-3 px-4 flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-3 text-center border-b-2 border-[#E2725B]" style={{
      backgroundColor: '#1B3A2D'
    }} data-id="element-4">
        <span className="text-white text-xs sm:text-sm font-medium" data-id="element-5">
          <span className="text-[#D4A843]" data-id="element-6">⚡</span>{' '}
          <strong data-id="element-7">FLASH SALE:</strong> The 3-Step Cortisol Reset — price of a
          lunch.
        </span>
        <span className="text-white text-xs sm:text-sm flex items-center gap-2" data-id="element-8">
          <span className="text-[#9CA3AF]" data-id="element-9">Ends in:</span>
          <CountdownTimer data-id="element-10" />
        </span>
      </div>

      {/* ━━━ SPLIT HERO SECTION ━━━ */}
      <section className="w-full px-4 pt-6 pb-6 md:pt-16 md:pb-16 max-w-6xl mx-auto" data-id="element-11">
        <div className="flex flex-col-reverse md:flex-row items-center gap-6 md:gap-12" data-id="element-12">
          {/* LEFT: Bundle Product Image */}
          <div className="w-full md:w-1/2 flex justify-center items-center py-2 md:py-0" data-id="element-13">
            <img src="https://cdn.magicpatterns.com/uploads/n9BafrgtqEN4hNAZPMsgRb/heylloyd-image-1773545127839.png" alt="The Cortisol Cure — Core Ebook and 5 Bonus Guides" className="w-full max-w-md rounded-2xl shadow-2xl" data-id="element-14" />
          </div>

          {/* RIGHT: CTA Block */}
          <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-15">
            <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{
            color: '#4A7C59',
            letterSpacing: '0.15em'
          }} data-id="element-16">
              Somatic Nervous System Protocol
            </p>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4" style={{
            fontFamily: 'Georgia, serif',
            color: '#111827'
          }} data-id="element-17">
              Stop Fighting the "Pooch." It's Not Fat. It's{' '}
              <span className="text-[#E2725B]" data-id="element-18">Cortisol.</span>
            </h1>

            <p className="text-base md:text-lg mb-5 leading-relaxed" style={{
            color: '#4B5563'
          }} data-id="element-19">
              The 10-minute somatic secret
              <br className="hidden sm:inline" data-id="element-20" /> 4,200+ moms use to switch off
              Survival Mode
              <br className="hidden sm:inline" data-id="element-21" /> and release stress-belly
              inflammation.
              <br data-id="element-22" />
              <strong className="text-[#111827]" data-id="element-23">
                No HIIT. No diets. No willpower.
              </strong>
            </p>

            <CTAButton large totalPrice={totalPrice} data-id="element-24" />

            <p className="text-xs mt-4 font-medium" style={{
            color: '#6B7280'
          }} data-id="element-25">
              One-time ${totalPrice} · Instant Digital Access ·{' '}
              <span className="inline-flex items-center gap-1" data-id="element-26">
                ✅ Lifetime Updates Included
              </span>
            </p>

            <div className="mt-6 flex items-center justify-center md:justify-start gap-2" data-id="element-27">
              <div className="flex text-[#D4A843]" data-id="element-28">
                <StarIcon className="w-4 h-4 fill-current" data-id="element-29" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-30" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-31" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-32" />
                <StarIcon className="w-4 h-4 fill-current" data-id="element-33" />
              </div>
              <span className="text-sm font-semibold text-[#1F2937]" data-id="element-34">
                4.9/5 from 2,100+ women
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ━━━ AUTHORITY ROW ━━━ */}
      <section className="w-full py-8 bg-[#F8F9FA] border-y border-gray-200" data-id="element-35">
        <div className="max-w-5xl mx-auto px-4 text-center" data-id="element-36">
          <p className="text-xs text-[#6B7280] uppercase tracking-widest font-bold mb-6" data-id="element-37">
            Research-backed by leading institutions
          </p>
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-12 text-[#9CA3AF] text-sm md:text-base font-bold uppercase tracking-widest" data-id="element-38">
            <span data-id="element-39">Stanford Neuroscience</span>
            <span data-id="element-40">Harvard Somatic Lab</span>
            <span data-id="element-41">Mayo Clinic Research</span>
            <span data-id="element-42">NIH Vagus Studies</span>
            <span data-id="element-43">Johns Hopkins</span>
          </div>
        </div>
      </section>

      {/* ━━━ VISUAL ANATOMY OF CORTISOL ━━━ */}
      <section className="w-full px-4 py-16 md:py-24 bg-white" data-id="element-44">
        <div className="max-w-4xl mx-auto" data-id="element-45">
          <div className="text-center mb-12" data-id="element-46">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111827] mb-4" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-47">
              The Anatomy of Cortisol Belly
            </h2>
            <p className="text-lg text-[#6B7280] font-medium" data-id="element-48">
              What's really happening inside your body
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-stretch justify-center gap-8 relative" data-id="element-49">
            {/* Left Card: Stress-Belly Mode */}
            <div className="flex-1 bg-[#1F2937] rounded-2xl border-t-4 border-t-[#EF4444] p-8 shadow-xl relative z-10" data-id="element-50">
              <div className="w-16 h-16 rounded-full bg-[#EF4444]/10 flex items-center justify-center mb-6 mx-auto border border-[#EF4444]/20" data-id="element-51">
                <FlameIcon className="w-8 h-8 text-[#EF4444]" data-id="element-52" />
              </div>
              <ul className="space-y-4 mb-8" data-id="element-53">
                <li className="flex items-center gap-3 text-gray-300" data-id="element-54">
                  <div className="w-2 h-2 rounded-full bg-[#EF4444] flex-shrink-0" data-id="element-55" />
                  <span data-id="element-56">Cortisol floods system</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300" data-id="element-57">
                  <div className="w-2 h-2 rounded-full bg-[#EF4444] flex-shrink-0" data-id="element-58" />
                  <span data-id="element-59">Fat stored around organs</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300" data-id="element-60">
                  <div className="w-2 h-2 rounded-full bg-[#EF4444] flex-shrink-0" data-id="element-61" />
                  <span data-id="element-62">Inflammation spikes</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300" data-id="element-63">
                  <div className="w-2 h-2 rounded-full bg-[#EF4444] flex-shrink-0" data-id="element-64" />
                  <span data-id="element-65">Sleep disrupted</span>
                </li>
              </ul>
              <div className="text-center mt-auto" data-id="element-66">
                <span className="inline-block px-4 py-1.5 bg-[#EF4444]/10 text-[#EF4444] text-xs font-bold uppercase tracking-widest rounded-full" data-id="element-67">
                  SURVIVAL MODE
                </span>
              </div>
            </div>

            {/* VS Divider */}
            <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white border border-gray-200 items-center justify-center z-20 shadow-lg font-bold text-[#6B7280] text-sm" data-id="element-68">
              VS
            </div>

            {/* Right Card: Regulated System */}
            <div className="flex-1 bg-[#1F2937] rounded-2xl border-t-4 border-t-[#22C55E] p-8 shadow-xl relative z-10" data-id="element-69">
              <div className="w-16 h-16 rounded-full bg-[#22C55E]/10 flex items-center justify-center mb-6 mx-auto border border-[#22C55E]/20" data-id="element-70">
                <HeartIcon className="w-8 h-8 text-[#22C55E]" data-id="element-71" />
              </div>
              <ul className="space-y-4 mb-8" data-id="element-72">
                <li className="flex items-center gap-3 text-gray-300" data-id="element-73">
                  <div className="w-2 h-2 rounded-full bg-[#22C55E] flex-shrink-0" data-id="element-74" />
                  <span data-id="element-75">Vagus nerve activated</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300" data-id="element-76">
                  <div className="w-2 h-2 rounded-full bg-[#22C55E] flex-shrink-0" data-id="element-77" />
                  <span data-id="element-78">Fat mobilized for energy</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300" data-id="element-79">
                  <div className="w-2 h-2 rounded-full bg-[#22C55E] flex-shrink-0" data-id="element-80" />
                  <span data-id="element-81">Inflammation reduced</span>
                </li>
                <li className="flex items-center gap-3 text-gray-300" data-id="element-82">
                  <div className="w-2 h-2 rounded-full bg-[#22C55E] flex-shrink-0" data-id="element-83" />
                  <span data-id="element-84">Deep restorative sleep</span>
                </li>
              </ul>
              <div className="text-center mt-auto" data-id="element-85">
                <span className="inline-block px-4 py-1.5 bg-[#22C55E]/10 text-[#22C55E] text-xs font-bold uppercase tracking-widest rounded-full" data-id="element-86">
                  REPAIR MODE
                </span>
              </div>
            </div>
          </div>

          <p className="text-center text-sm text-[#9CA3AF] italic mt-8" data-id="element-87">
            Based on peer-reviewed somatic research
          </p>
        </div>
      </section>

      {/* ━━━ COMPARISON TABLE ━━━ */}
      <section className="w-full px-4 py-16 md:py-24" style={{
      backgroundColor: '#1B3A2D'
    }} data-id="element-88">
        <div className="max-w-4xl mx-auto" data-id="element-89">
          <div className="text-center mb-12" data-id="element-90">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-91">
              Why Everything You've Tried Has Failed
            </h2>
            <p className="text-lg text-[#4A7C59] font-medium" data-id="element-92">
              Traditional Fitness vs. The Somatic Reset
            </p>
          </div>

          <div className="bg-[#1F2937] rounded-2xl overflow-hidden shadow-2xl border border-gray-700" data-id="element-93">
            {/* Headers */}
            <div className="grid grid-cols-2 border-b border-gray-700" data-id="element-94">
              <div className="p-4 md:p-6 bg-red-900/20 text-center border-r border-gray-700" data-id="element-95">
                <h3 className="text-lg md:text-xl font-bold text-white" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-96">
                  Traditional Fitness
                </h3>
              </div>
              <div className="p-4 md:p-6 bg-green-900/20 text-center" data-id="element-97">
                <h3 className="text-lg md:text-xl font-bold text-white" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-98">
                  The Somatic Reset
                </h3>
              </div>
            </div>

            {/* Rows */}
            <div className="divide-y divide-gray-700" data-id="element-99">
              <ComparisonRow left="HIIT & Intense Cardio" right="10-min gentle flows" data-id="element-100" />
              <ComparisonRow left="Spikes cortisol 200-300%" right="Activates vagus nerve calm" data-id="element-101" />
              <ComparisonRow left="45-60 min/day minimum" right="10 minutes in your PJs" data-id="element-102" />
              <ComparisonRow left="Leaves you depleted" right="Energizes & restores" data-id="element-103" />
              <ComparisonRow left="Months of grinding" right="Shifts felt in 7 days" data-id="element-104" />
            </div>
          </div>

          <div className="mt-12 text-center max-w-lg mx-auto" data-id="element-105">
            <CTAButton large totalPrice={totalPrice} data-id="element-106" />
          </div>
        </div>
      </section>

      {/* ━━━ 3-STEP QUICK WIN TIMELINE ━━━ */}
      <section className="w-full px-4 py-16 md:py-24 bg-[#F8F9FA]" data-id="element-107">
        <div className="max-w-5xl mx-auto" data-id="element-108">
          <div className="text-center mb-16" data-id="element-109">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111827] mb-4" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-110">
              Your Quick Win in 3 Steps
            </h2>
          </div>

          <div className="relative" data-id="element-111">
            {/* Connecting Line (Desktop) */}
            <div className="hidden md:block absolute top-12 left-[16.66%] right-[16.66%] h-0.5 border-t-2 border-dashed border-gray-300 z-0" data-id="element-112" />

            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-113">
              {/* Step 1 */}
              <div className="flex flex-col items-center text-center relative" data-id="element-114">
                <div className="w-8 h-8 rounded-full bg-[#1B3A2D] text-white font-bold flex items-center justify-center text-sm mb-4 border-4 border-[#F8F9FA] shadow-sm" data-id="element-115">
                  1
                </div>
                <div className="w-20 h-20 rounded-full bg-white border border-gray-200 shadow-md flex items-center justify-center mb-6" data-id="element-116">
                  <div className="w-14 h-14 rounded-full bg-[#E2725B]/10 flex items-center justify-center" data-id="element-117">
                    <ZapIcon className="w-6 h-6 text-[#E2725B]" data-id="element-118" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-[#111827] mb-3" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-119">
                  Join Instantly
                </h3>
                <p className="text-[#6B7280] leading-relaxed" data-id="element-120">
                  One click. Instant access to everything.
                </p>
              </div>

              {/* Step 2 */}
              <div className="flex flex-col items-center text-center relative" data-id="element-121">
                <div className="w-8 h-8 rounded-full bg-[#1B3A2D] text-white font-bold flex items-center justify-center text-sm mb-4 border-4 border-[#F8F9FA] shadow-sm" data-id="element-122">
                  2
                </div>
                <div className="w-20 h-20 rounded-full bg-white border border-gray-200 shadow-md flex items-center justify-center mb-6" data-id="element-123">
                  <div className="w-14 h-14 rounded-full bg-[#E2725B]/10 flex items-center justify-center" data-id="element-124">
                    <HeadphonesIcon className="w-6 h-6 text-[#E2725B]" data-id="element-125" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-[#111827] mb-3" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-126">
                  Play One Audio
                </h3>
                <p className="text-[#6B7280] leading-relaxed" data-id="element-127">
                  Start with the 5-min Emergency Calm reset.
                </p>
              </div>

              {/* Step 3 */}
              <div className="flex flex-col items-center text-center relative" data-id="element-128">
                <div className="w-8 h-8 rounded-full bg-[#1B3A2D] text-white font-bold flex items-center justify-center text-sm mb-4 border-4 border-[#F8F9FA] shadow-sm" data-id="element-129">
                  3
                </div>
                <div className="w-20 h-20 rounded-full bg-white border border-gray-200 shadow-md flex items-center justify-center mb-6" data-id="element-130">
                  <div className="w-14 h-14 rounded-full bg-[#E2725B]/10 flex items-center justify-center" data-id="element-131">
                    <HeartIcon className="w-6 h-6 text-[#E2725B]" data-id="element-132" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-[#111827] mb-3" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-133">
                  Feel the Reset
                </h3>
                <p className="text-[#6B7280] leading-relaxed" data-id="element-134">
                  Notice the shift in your nervous system within minutes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ━━━ WHAT YOU GET (6 CARDS) ━━━ */}
      <section className="w-full px-4 py-16 md:py-24 bg-[#F8F9FA]" data-id="element-135">
        <div className="max-w-5xl mx-auto" data-id="element-136">
          <div className="text-center mb-12" data-id="element-137">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111827] mb-4" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-138">
              What's Inside Your Bundle
            </h2>
            <p className="text-lg text-[#4B5563] font-medium" data-id="element-139">
              1 Core Protocol + 5 Exclusive Bonuses
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-140">
            {/* Card 1: Featured Core Product */}
            <div className="md:col-span-2 rounded-2xl overflow-hidden shadow-xl bg-[#1B3A2D] text-white border border-[#2C5E3F] relative" data-id="element-141">
              <div className="absolute top-0 left-0 right-0 h-2 bg-[#E2725B]" data-id="element-142" />
              <div className="p-6 md:p-10 flex flex-col md:flex-row items-center md:items-start gap-6" data-id="element-143">
                <div className="w-20 h-20 rounded-full bg-[#2C5E3F] flex items-center justify-center flex-shrink-0 border-2 border-[#4A7C59]" data-id="element-144">
                  <BookOpenIcon className="w-10 h-10 text-white" data-id="element-145" />
                </div>
                <div className="flex-1 text-center md:text-left" data-id="element-146">
                  <div className="inline-block px-3 py-1 bg-[#2C5E3F] text-white text-xs font-bold uppercase tracking-widest rounded-full mb-3" data-id="element-147">
                    Core Program
                  </div>
                  <h3 className="text-2xl md:text-3xl font-bold mb-3" style={{
                  fontFamily: 'Georgia, serif'
                }} data-id="element-148">
                    The Cortisol Cure Core Ebook
                  </h3>
                  <p className="text-[#9CA3AF] text-base md:text-lg mb-4 leading-relaxed" data-id="element-149">
                    The step-by-step 21-day somatic system to reset your nervous
                    system, lower inflammation, and signal your body to release
                    stubborn stress-fat.
                  </p>
                  <div className="flex items-center justify-center md:justify-start gap-3" data-id="element-150">
                    <span className="text-[#9CA3AF] line-through font-medium" data-id="element-151">
                      $197 Value
                    </span>
                    <span className="text-[#E2725B] font-bold bg-[#E2725B]/10 px-3 py-1 rounded-full" data-id="element-152">
                      INCLUDED
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Bonus Cards 2-6 */}
            <BundleCard icon={<UtensilsCrossedIcon className="w-6 h-6 text-[#4A7C59]" data-id="element-154" />} title="7-Day Anti-Inflammatory No-Cook Meal Plan" desc="Eat to lower cortisol without spending hours prepping in the kitchen." value="$97" data-id="element-153" />
            <BundleCard icon={<HeadphonesIcon className="w-6 h-6 text-[#4A7C59]" data-id="element-156" />} title="5-Minute Emergency Calm Audio Series" desc="Guided audio resets for when you feel a panic or stress spike coming on." value="$67" data-id="element-155" />
            <BundleCard icon={<ZapIcon className="w-6 h-6 text-[#4A7C59]" data-id="element-158" />} title="3-Min School Run Panic Button" desc="Discrete somatic hacks for the car or kitchen to stop the early morning snap instantly." value="$47" data-id="element-157" />
            <BundleCard icon={<MoonIcon className="w-6 h-6 text-[#4A7C59]" data-id="element-160" />} title="Wired-But-Tired Sleep Induction" desc="De-activate your Internal Alarm and fall asleep in under 12 minutes without supplements." value="$67" data-id="element-159" />
            <BundleCard icon={<LeafIcon className="w-6 h-6 text-[#4A7C59]" data-id="element-162" />} title="Cortisol-Safe Coffee Guide" desc="Keep your morning ritual without spiking stress-fat or jitters. The Buffer Protocol." value="$27" data-id="element-161" />
          </div>
        </div>
      </section>

      {/* ━━━ OFFER / PRICING SECTION ━━━ */}
      <section id="offer" className="w-full px-4 py-16 md:py-24 bg-white" data-id="element-163">
        <div className="max-w-2xl mx-auto" data-id="element-164">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111827] mb-10 text-center" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-165">
            Secure Your Bundle Today
          </h2>

          <div className="rounded-2xl overflow-hidden border-2 border-[#2C5E3F] shadow-2xl bg-[#F8F9FA]" data-id="element-166">
            {/* Bundle Image */}
            <div className="p-6 pb-2 flex justify-center bg-white border-b border-gray-100" data-id="element-167">
              <img src="https://cdn.magicpatterns.com/uploads/n9BafrgtqEN4hNAZPMsgRb/heylloyd-image-1773545127839.png" alt="The Cortisol Cure Bundle" className="w-full max-w-xs rounded-xl" data-id="element-168" />
            </div>

            {/* Price Breakdown List */}
            <div className="divide-y divide-gray-200" data-id="element-169">
              <OfferLineItem icon={<BookOpenIcon className="w-5 h-5 text-[#1B3A2D]" data-id="element-171" />} label="Core Program" title="The Cortisol Cure Core Ebook" value="$197" featured data-id="element-170" />
              <OfferLineItem icon={<UtensilsCrossedIcon className="w-5 h-5 text-[#4A7C59]" data-id="element-173" />} label="Bonus #1" title="7-Day Anti-Inflammatory No-Cook Meal Plan" value="$97" data-id="element-172" />
              <OfferLineItem icon={<HeadphonesIcon className="w-5 h-5 text-[#4A7C59]" data-id="element-175" />} label="Bonus #2" title="5-Minute Emergency Calm Audio Series" value="$67" data-id="element-174" />
              <OfferLineItem icon={<ZapIcon className="w-5 h-5 text-[#4A7C59]" data-id="element-177" />} label="Bonus #3" title="3-Min School Run Panic Button" value="$47" data-id="element-176" />
              <OfferLineItem icon={<MoonIcon className="w-5 h-5 text-[#4A7C59]" data-id="element-179" />} label="Bonus #4" title="Wired-But-Tired Sleep Induction" value="$67" data-id="element-178" />
              <OfferLineItem icon={<LeafIcon className="w-5 h-5 text-[#4A7C59]" data-id="element-181" />} label="Bonus #5" title="Cortisol-Safe Coffee Guide" value="$27" data-id="element-180" />
            </div>

            {/* Total + Price */}
            <div className="p-6 md:p-8 bg-white border-t-2 border-[#2C5E3F]" data-id="element-182">
              <div className="flex items-center justify-center gap-3 mb-6" data-id="element-183">
                <span className="text-lg font-medium text-[#4B5563]" data-id="element-184">
                  Total Bundle Value:
                </span>
                <span className="text-2xl font-bold text-[#2C5E3F] line-through" data-id="element-185">
                  $502.00
                </span>
              </div>

              <div className="flex flex-col items-center justify-center mb-2" data-id="element-186">
                <span className="text-sm font-bold uppercase tracking-widest text-[#6B7280] mb-3" data-id="element-187">
                  Today Only
                </span>
                <div className="text-7xl md:text-8xl font-bold text-[#E2725B] leading-none" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-188">
                  ${totalPrice}
                </div>
              </div>

              <p className="text-sm text-[#4B5563] font-medium mt-4 mb-8 text-center" data-id="element-189">
                One-Time Payment • 5 Exclusive Bonuses • Instant Digital Access
              </p>

              {/* ━━━ ORDER BUMPS ━━━ */}
              <div className="mb-6 space-y-4" data-id="element-190">
                {/* ORDER BUMP #1: "Cortisol Cravings" Snack Swap Vault */}
                <label className={`block rounded-xl p-4 md:p-5 text-left cursor-pointer transition-all duration-200 relative overflow-hidden ${!bump1 ? 'order-bump-flash' : ''}`} style={{
                backgroundColor: bump1 ? '#F0F7F2' : '#FDFBF7',
                border: bump1 ? '2px solid #4A7C59' : '2px dashed #4A7C59',
                boxShadow: bump1 ? '0 0 0 1px #4A7C59, 0 4px 12px rgba(74,124,89,0.15)' : 'none'
              }} data-id="element-191">
                  {/* Altamente recomendado ribbon */}
                  <div className="absolute top-0 right-0 bg-[#E2725B] text-white text-[9px] font-bold uppercase tracking-wider px-3 py-1 rounded-bl-lg" data-id="element-192">
                    ⭐ Altamente recomendado
                  </div>
                  <div className="flex items-start gap-3" data-id="element-193">
                    <div className="flex-shrink-0 pt-0.5" data-id="element-194">
                      <div className={`w-6 h-6 rounded-md border-2 flex items-center justify-center transition-all duration-200 ${bump1 ? 'bg-[#4A7C59] border-[#4A7C59]' : 'bg-white border-gray-300'}`} data-id="element-195">
                        {bump1 && <CheckIcon className="w-4 h-4 text-white stroke-[3]" data-id="element-196" />}
                      </div>
                      <input type="checkbox" checked={bump1} onChange={() => setBump1(!bump1)} className="sr-only" data-id="element-197" />
                    </div>
                    <img src="https://cdn.magicpatterns.com/uploads/ouq2zDSZtGWvtJd8XHbYGH/cortisol_cravings.jpg" alt="Cortisol Cravings — 7-Day Snack Swap Vault" className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover flex-shrink-0 shadow-md" data-id="element-198" />
                    <div className="flex-1 min-w-0" data-id="element-199">
                      <span className="inline-block px-2 py-0.5 bg-[#E2725B]/10 text-[#E2725B] text-[10px] font-bold uppercase tracking-widest rounded mb-1.5" data-id="element-200">
                        🔥 Most Popular
                      </span>
                      <h4 className="text-sm md:text-base font-bold text-[#111827] leading-snug mb-1.5" style={{
                      fontFamily: 'Georgia, serif'
                    }} data-id="element-201">
                        Add the "Cortisol Cravings" Snack Swap Vault
                      </h4>
                      <p className="text-xs text-[#4B5563] leading-relaxed mb-2" data-id="element-202">
                        Stop the 3PM crash from hijacking your reset. Get a
                        7-day snack plan + "cravings emergency" cheat sheet with
                        cortisol-safe swaps that keep blood sugar stable. No
                        tracking, no prep, no willpower.
                      </p>
                      <p className="text-xs font-bold text-[#1B3A2D]" data-id="element-203">
                        Add for just{' '}
                        <span className="text-[#E2725B] text-sm" data-id="element-204">$9.00</span>{' '}
                        <span className="text-[#9CA3AF] line-through font-medium" data-id="element-205">
                          $47
                        </span>
                      </p>
                    </div>
                  </div>
                </label>

                {/* ORDER BUMP #2: "The 10-Minute Reset Schedule" */}
                <label className={`block rounded-xl p-4 md:p-5 text-left cursor-pointer transition-all duration-200 relative overflow-hidden ${!bump2 ? 'order-bump-flash' : ''}`} style={{
                backgroundColor: bump2 ? '#FFFBF0' : '#FFFDF8',
                border: bump2 ? '2px solid #D4A843' : '2px solid #E5D9B6',
                boxShadow: bump2 ? '0 0 0 1px #D4A843, 0 4px 12px rgba(212,168,67,0.15)' : 'none'
              }} data-id="element-206">
                  {/* Altamente recomendado ribbon */}
                  <div className="absolute top-0 right-0 bg-[#D4A843] text-white text-[9px] font-bold uppercase tracking-wider px-3 py-1 rounded-bl-lg" data-id="element-207">
                    ⭐ Altamente recomendado
                  </div>
                  <div className="flex items-start gap-3" data-id="element-208">
                    <div className="flex-shrink-0 pt-0.5" data-id="element-209">
                      <div className={`w-6 h-6 rounded-md border-2 flex items-center justify-center transition-all duration-200 ${bump2 ? 'bg-[#D4A843] border-[#D4A843]' : 'bg-white border-gray-300'}`} data-id="element-210">
                        {bump2 && <CheckIcon className="w-4 h-4 text-white stroke-[3]" data-id="element-211" />}
                      </div>
                      <input type="checkbox" checked={bump2} onChange={() => setBump2(!bump2)} className="sr-only" data-id="element-212" />
                    </div>
                    <img src="https://cdn.magicpatterns.com/uploads/oFHFzaLWA9WxwnXTdXZFfY/10-m_reset.png" alt="The 10-Minute Reset Schedule" className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover flex-shrink-0 shadow-md" data-id="element-213" />
                    <div className="flex-1 min-w-0" data-id="element-214">
                      <span className="inline-block px-2 py-0.5 bg-[#D4A843]/10 text-[#D4A843] text-[10px] font-bold uppercase tracking-widest rounded mb-1.5" data-id="element-215">
                        ⚡ Upgrade
                      </span>
                      <h4 className="text-sm md:text-base font-bold text-[#111827] leading-snug mb-1.5" style={{
                      fontFamily: 'Georgia, serif'
                    }} data-id="element-216">
                        Add the 10-Minute Reset Schedule
                      </h4>
                      <p className="text-xs text-[#4B5563] leading-relaxed mb-2" data-id="element-217">
                        Stop guessing when to do the resets. Done-for-you
                        Morning / Midday / Night schedule with "IF-THEN" rules
                        for every day type (busy, no-sleep, PMS, high-stress).
                        No thinking required.
                      </p>
                      <p className="text-xs font-bold text-[#1B3A2D]" data-id="element-218">
                        Add for just{' '}
                        <span className="text-[#E2725B] text-sm" data-id="element-219">$9.00</span>{' '}
                        <span className="text-[#9CA3AF] line-through font-medium" data-id="element-220">
                          $47
                        </span>
                      </p>
                    </div>
                  </div>
                </label>
              </div>

              {/* Dynamic total */}
              {(bump1 || bump2) && <div className="mb-4 text-center" data-id="element-221">
                  <p className="text-sm text-[#4B5563]" data-id="element-222">
                    Your total:{' '}
                    <span className="font-bold text-[#111827] text-lg" data-id="element-223">
                      ${totalPrice}
                    </span>
                    <span className="text-xs text-[#9CA3AF] ml-1" data-id="element-224">
                      ($14.27{bump1 ? ' + $9.00' : ''}
                      {bump2 ? ' + $9.00' : ''})
                    </span>
                  </p>
                </div>}

              <PurchasePageButton totalPrice={totalPrice} purchaseUrl={purchaseUrl} data-id="element-225" />

              {/* Risk Reversal Badge — immediately below CTA */}
              <div className="mt-6 bg-[#F8F9FA] border border-[#E5E7EB] rounded-xl p-4 flex items-start gap-3 text-left" data-id="element-226">
                <div className="w-10 h-10 rounded-full bg-[#D4A843]/10 flex items-center justify-center flex-shrink-0" data-id="element-227">
                  <ShieldIcon className="w-5 h-5 text-[#D4A843]" data-id="element-228" />
                </div>
                <div data-id="element-229">
                  <h4 className="font-bold text-[#111827] text-sm mb-0.5" style={{
                  fontFamily: 'Georgia, serif'
                }} data-id="element-230">
                    Transformation Guarantee
                  </h4>
                  <p className="text-xs text-[#4B5563] leading-relaxed" data-id="element-231">
                    Real shifts in 7 days or we'll send you a specialized Deep
                    Sleep workshop for free. Safe & Secure Checkout.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ━━━ SOCIAL PROOF ━━━ */}
      <section className="w-full px-4 py-16 md:py-24 bg-[#1B3A2D]" data-id="element-232">
        <div className="max-w-4xl mx-auto" data-id="element-233">
          <div className="text-center mb-12" data-id="element-234">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-235">
              Real Results From Real Women
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-236">
            <TestimonialCard quote="I lost 4 inches off my waist in 21 days without stepping foot in a gym. I finally have energy to play with my kids after work. This literally saved my sanity." name="Jennifer S." detail="39 · Texas" data-id="element-237" />
            <TestimonialCard quote="I thought I needed more caffeine. Turns out I just needed to regulate my vagus nerve. The 10-minute somatic flows are now non-negotiable in my morning." name="Michelle R." detail="42 · Florida" data-id="element-238" />
          </div>
        </div>
      </section>

      {/* ━━━ FAQ ACCORDION ━━━ */}
      <section className="w-full px-4 py-16 md:py-24 bg-[#F8F9FA]" data-id="element-239">
        <div className="max-w-3xl mx-auto" data-id="element-240">
          <div className="text-center mb-12" data-id="element-241">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111827] mb-4" style={{
            fontFamily: 'Georgia, serif'
          }} data-id="element-242">
              Frequently Asked Questions
            </h2>
          </div>

          <div className="space-y-4" data-id="element-243">
            <FaqAccordion index={0} openIndex={openFaq} setOpenIndex={setOpenFaq} question="What exactly is The Cortisol Cure?" answer="It's a digital protocol consisting of an ebook and audio/video guides that teach you 10-minute somatic movements. These movements are scientifically designed to signal safety to your nervous system, lowering cortisol and reducing stress-induced inflammation and belly fat." data-id="element-244" />
            <FaqAccordion index={1} openIndex={openFaq} setOpenIndex={setOpenFaq} question="How quickly will I see results?" answer="Most women report feeling a significant shift in their energy and anxiety levels within the first 3 to 7 days. Physical changes, like reduced bloating and 'cortisol belly', typically become noticeable within 14 to 21 days of consistent 10-minute daily practice." data-id="element-245" />
            <FaqAccordion index={2} openIndex={openFaq} setOpenIndex={setOpenFaq} question="Is this a subscription?" answer="No. This is a one-time payment of $14.27. You get lifetime access to the core ebook and all 5 bonuses immediately after purchase. There are no hidden fees or recurring charges." data-id="element-246" />
          </div>
        </div>
      </section>

      {/* ━━━ FINAL CTA ━━━ */}
      <section className="w-full px-4 py-20 md:py-32 text-center bg-[#111827]" data-id="element-247">
        <div className="max-w-3xl mx-auto" data-id="element-248">
          <p className="text-sm font-bold uppercase tracking-widest mb-4 text-[#D4A843]" data-id="element-249">
            Your Body Is Ready to Heal
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-8 text-white leading-tight" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-250">
            You Deserve to Feel Like Yourself Again.
          </h2>
          <div className="max-w-lg mx-auto" data-id="element-251">
            <CTAButton dark totalPrice={totalPrice} data-id="element-252" />
          </div>
          <p className="text-sm mt-6 text-[#6B7280] font-medium" data-id="element-253">
            One-Time Payment of ${totalPrice} · All Sales Final · Instant Access
          </p>
        </div>
      </section>

      {/* ━━━ FOOTER ━━━ */}
      <footer className="w-full px-4 py-8 text-center bg-[#111111] border-t border-gray-800" data-id="element-254">
        <p className="text-xs text-gray-500 max-w-2xl mx-auto leading-relaxed" data-id="element-255">
          © 2025 The Cortisol Cure. All rights reserved. · Results may vary.
          This product is not intended to diagnose, treat, cure, or prevent any
          disease.
        </p>
      </footer>

      {/* ━━━ STICKY MOBILE CTA BAR ━━━ */}
      <div className={`fixed bottom-0 left-0 right-0 z-50 px-4 py-3 md:hidden transition-transform duration-300 shadow-[0_-4px_20px_rgba(0,0,0,0.15)] ${showStickyBar ? 'translate-y-0' : 'translate-y-full'}`} style={{
      backgroundColor: '#111827',
      borderTop: '1px solid #1F2937'
    }} data-id="element-256">
        <div className="flex items-center gap-3" data-id="element-257">
          <div className="flex-shrink-0 text-center" data-id="element-258">
            <span className="block text-xs text-[#9CA3AF] line-through leading-none" data-id="element-259">
              $502
            </span>
            <span className="block text-xl font-bold text-white leading-tight" data-id="element-260">
              ${totalPrice}
            </span>
          </div>
          <a href={purchaseUrl} className="flex-1 block text-center font-bold uppercase rounded-xl py-4 text-sm tracking-widest shadow-lg active:scale-95 transition-all" style={{
          backgroundColor: '#E2725B',
          color: '#FFFFFF',
          textDecoration: 'none'
        }} onMouseEnter={e => {
          ;
          (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#F0845A';
        }} onMouseLeave={e => {
          ;
          (e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#E2725B';
        }} data-id="element-261">
            GET THE BUNDLE
          </a>
        </div>
      </div>
    </div>;
}
/* ━━━ SUB-COMPONENTS ━━━ */
function ComparisonRow({
  left,
  right
}: {
  left: string;
  right: string;
}) {
  return <div className="grid grid-cols-2" data-id="element-262">
      <div className="p-4 md:p-6 flex items-center gap-3 border-r border-gray-700 bg-[#1F2937]" data-id="element-263">
        <div className="w-6 h-6 rounded-full bg-red-900/30 flex items-center justify-center flex-shrink-0" data-id="element-264">
          <XIcon className="w-4 h-4 text-[#EF4444]" data-id="element-265" />
        </div>
        <span className="text-sm md:text-base text-gray-300 font-medium leading-snug" data-id="element-266">
          {left}
        </span>
      </div>
      <div className="p-4 md:p-6 flex items-center gap-3 bg-[#1F2937]" data-id="element-267">
        <div className="w-6 h-6 rounded-full bg-green-900/30 flex items-center justify-center flex-shrink-0" data-id="element-268">
          <CheckIcon className="w-4 h-4 text-[#22C55E]" data-id="element-269" />
        </div>
        <span className="text-sm md:text-base text-white font-medium leading-snug" data-id="element-270">
          {right}
        </span>
      </div>
    </div>;
}
function BundleCard({
  icon,
  title,
  desc,
  value
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
  value: string;
}) {
  return <div className="bg-white rounded-xl shadow-md border border-gray-200 border-l-4 border-l-[#2C5E3F] p-5 md:p-6 flex flex-col h-full" data-id="element-271">
      <div className="flex items-start gap-4 mb-4" data-id="element-272">
        <div className="w-12 h-12 rounded-full bg-[#F8F9FA] border border-gray-200 flex items-center justify-center flex-shrink-0" data-id="element-273">
          {icon}
        </div>
        <div data-id="element-274">
          <span className="inline-block px-2 py-1 bg-[#E2725B]/10 text-[#E2725B] text-[10px] font-bold uppercase tracking-widest rounded mb-2" data-id="element-275">
            Bonus
          </span>
          <h4 className="text-lg font-bold text-[#111827] leading-tight" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-276">
            {title}
          </h4>
        </div>
      </div>
      <p className="text-sm text-[#4B5563] leading-relaxed mb-6 flex-1" data-id="element-277">
        {desc}
      </p>
      <div className="flex items-center gap-3 pt-4 border-t border-gray-100 mt-auto" data-id="element-278">
        <span className="text-sm text-[#9CA3AF] line-through font-medium" data-id="element-279">
          {value} Value
        </span>
        <span className="text-sm font-bold text-[#2C5E3F]" data-id="element-280">INCLUDED</span>
      </div>
    </div>;
}
function TestimonialCard({
  quote,
  name,
  detail
}: {
  quote: string;
  name: string;
  detail: string;
}) {
  return <div className="bg-[#1F2937] rounded-2xl p-6 md:p-8 border border-gray-700 flex flex-col h-full shadow-xl" data-id="element-281">
      <div className="flex gap-1 mb-4" data-id="element-282">
        {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-4 h-4 text-[#D4A843] fill-current" data-id="element-283" />)}
      </div>
      <p className="text-base md:text-lg text-gray-300 italic mb-6 flex-1 leading-relaxed" style={{
      fontFamily: 'Georgia, serif'
    }} data-id="element-284">
        "{quote}"
      </p>
      <div className="flex items-center gap-3" data-id="element-285">
        <div className="w-10 h-10 rounded-full bg-[#2C5E3F] flex items-center justify-center text-white font-bold text-sm border border-[#4A7C59]" data-id="element-286">
          {name.charAt(0)}
        </div>
        <div data-id="element-287">
          <p className="text-sm font-bold text-white" data-id="element-288">{name}</p>
          <p className="text-xs text-gray-400" data-id="element-289">{detail}</p>
        </div>
      </div>
    </div>;
}
function FaqAccordion({
  index,
  openIndex,
  setOpenIndex,
  question,
  answer
}: {
  index: number;
  openIndex: number | null;
  setOpenIndex: (i: number | null) => void;
  question: string;
  answer: string;
}) {
  const isOpen = openIndex === index;
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-290">
      <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-291">
        <span className="text-base md:text-lg font-bold text-[#111827]" style={{
        fontFamily: 'Georgia, serif'
      }} data-id="element-292">
          {question}
        </span>
        <div className="w-8 h-8 rounded-full bg-[#E2725B]/10 flex items-center justify-center flex-shrink-0 ml-4" data-id="element-293">
          {isOpen ? <MinusIcon className="w-5 h-5 text-[#E2725B] stroke-[3]" data-id="element-294" /> : <PlusIcon className="w-5 h-5 text-[#E2725B] stroke-[3]" data-id="element-295" />}
        </div>
      </button>
      <div className={`px-6 pb-5 ${isOpen ? 'block' : 'hidden'}`} data-id="element-296">
        <p className="text-[#4B5563] leading-relaxed text-sm md:text-base" data-id="element-297">
          {answer}
        </p>
      </div>
    </div>;
}
function CTAButton({
  large = false,
  dark = false,
  totalPrice = '14.27'
}: {
  large?: boolean;
  dark?: boolean;
  totalPrice?: string;
}) {
  if (large) {
    return <SalesPageButton totalPrice={totalPrice} data-id="element-298" />;
  }
  return <button onClick={() => document.getElementById('offer')?.scrollIntoView({
    behavior: 'smooth'
  })} className="inline-block w-full max-w-lg font-bold uppercase rounded-xl text-center transition-all duration-200 active:scale-95 cursor-pointer px-5 py-4 text-sm shadow-lg" style={{
    backgroundColor: '#E2725B',
    color: '#FFFFFF',
    letterSpacing: '0.05em',
    border: 'none'
  }} onMouseEnter={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#F0845A';
  }} onMouseLeave={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#E2725B';
  }} data-id="element-299">
      GET THE CORTISOL CURE — ${totalPrice}
    </button>;
}
/** SalesPageButton — scrolls to the pricing section */
function SalesPageButton({
  totalPrice = '14.27'
}: {
  totalPrice?: string;
}) {
  const handleScrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <button onClick={handleScrollToOffer} className="inline-block w-full max-w-lg font-bold uppercase rounded-xl text-center transition-all duration-200 active:scale-95 cursor-pointer px-6 py-5 text-sm md:text-base shadow-xl" style={{
    backgroundColor: '#E2725B',
    color: '#FFFFFF',
    letterSpacing: '0.05em',
    border: 'none'
  }} onMouseEnter={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#F0845A';
  }} onMouseLeave={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#E2725B';
  }} data-id="element-300">
      GET THE CORTISOL CURE — ${totalPrice}
    </button>;
}
function OfferLineItem({
  icon,
  label,
  title,
  value,
  featured = false
}: {
  icon: React.ReactNode;
  label: string;
  title: string;
  value: string;
  featured?: boolean;
}) {
  return <div className={`flex items-center gap-4 px-5 py-4 md:px-6 md:py-5 ${featured ? 'bg-[#1B3A2D]' : 'bg-white'}`} data-id="element-301">
      <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${featured ? 'bg-[#2C5E3F] border border-[#4A7C59]' : 'bg-[#F8F9FA] border border-gray-200'}`} data-id="element-302">
        {icon}
      </div>
      <div className="flex-1 min-w-0" data-id="element-303">
        <span className={`text-[10px] font-bold uppercase tracking-widest block mb-0.5 ${featured ? 'text-[#4A7C59]' : 'text-[#E2725B]'}`} data-id="element-304">
          {label}
        </span>
        <h4 className={`text-sm md:text-base font-bold leading-snug ${featured ? 'text-white' : 'text-[#111827]'}`} data-id="element-305">
          {title}
        </h4>
      </div>
      <div className="text-right flex-shrink-0" data-id="element-306">
        <span className={`text-xs line-through block ${featured ? 'text-[#9CA3AF]' : 'text-[#9CA3AF]'}`} data-id="element-307">
          {value}
        </span>
        <span className={`text-xs font-bold ${featured ? 'text-[#22C55E]' : 'text-[#22C55E]'}`} data-id="element-308">
          {featured ? 'INCLUDED' : 'FREE'}
        </span>
      </div>
    </div>;
}
/** PurchasePageButton — navigates directly to the Shopify purchase URL */
function PurchasePageButton({
  totalPrice = '14.27',
  purchaseUrl = CART_URLS.base
}: {
  totalPrice?: string;
  purchaseUrl?: string;
}) {
  const handlePurchase = () => {
    window.fbq('track', 'AddToCart', {
      content_name: 'The Cortisol Cure',
      content_type: 'product',
      value: parseFloat(totalPrice),
      currency: 'USD'
    });
    window.location.href = purchaseUrl;
  };
  return <button onClick={handlePurchase} className="inline-block w-full max-w-lg font-bold uppercase rounded-xl text-center transition-all duration-200 active:scale-95 cursor-pointer px-6 py-5 text-sm md:text-base shadow-xl" style={{
    backgroundColor: '#E2725B',
    color: '#FFFFFF',
    letterSpacing: '0.05em',
    border: 'none'
  }} onMouseEnter={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#F0845A';
  }} onMouseLeave={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#E2725B';
  }} data-id="element-309">
      GET THE CORTISOL CURE — ${totalPrice}
    </button>;
}